import { useHistory } from 'react-router-dom';

import { removeStorageRecord } from '../api/api';

import useUser from './useUser';
import useGlobalStatus from './useGlobalStatus';
import { PAGE } from '../constants/url';

import * as urlConstants from '../constants/url';

import {
  ALERT_TYPE,
  ERROR_CERTIFICATE,
  ERROR_SYSTEMCONNECT
} from '../constants/alertMsg';

const useApiError = () => {
  const history = useHistory();
  const { setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { handleAlertMsgSettings } = useGlobalStatus();

  const handleApiErrorStatus = (res) => {
    if (res.status === 401) {
      removeStorageRecord();
      setAuthStatusMsg(ERROR_CERTIFICATE);
      setUserData(null);
      history.push(urlConstants.PAGE_LOGIN);
    } else {
      console.log(res)
      handleAlertMsgSettings(true, { type: ALERT_TYPE.ERROR, msg: `${ERROR_SYSTEMCONNECT} ${res.status || ''}` });
    }
  }

  return { handleApiErrorStatus };
};

export default useApiError;